import {
  Directive,
  ElementRef,
  HostBinding,
  HostListener,
  Input,
  OnChanges,
  SimpleChanges
} from '@angular/core';

@Directive({
  selector: 'input[app-number-formatter]'
})
export class FormatNumberDirective {
  /**
   * Class constructor
   * @param hostElement
   */
  constructor(private hostElement: ElementRef) {}

  /**
   * Event handler for host's change event
   * @param e
   */
  @HostListener('change', ['$event']) onChange(e: any) {
    const formatter = new Intl.NumberFormat('en-US');
    this.hostElement.nativeElement['value'] = formatter.format(
      this.hostElement.nativeElement['value']
    );
  }

  /**
   * Event handler for host's paste event
   * @param e
   */
  @HostListener('paste', ['$event']) onPaste(e: any) {
    // get and validate data from clipboard
    let value = e.clipboardData.getData('text/plain');
    const formatter = new Intl.NumberFormat('en-US');
    this.hostElement.nativeElement['value'] = value;
    e.preventDefault();
  }
}
